<template>
    <div class="right-bar__ruler communication">
        <h3 class="right-bar__header">{{ $t('translation.communication') }}</h3>

        <div class="col">
            <div class="communication__device-list device-list">
                <div class="device-list__header">
                    <h4 class="device-list__header-text">{{ $t('translation.devicesList') }}</h4>
                    <button type="button" @click="scanDevice" class="device-list__button-scan">
                        {{ $t('translation.scanDevices') }}
                    </button>
                </div>
                <div class="device-list__body">
                    <div class="device-list__tabs">
                        <div
                            class="device-list__tab"
                            @click="changeTab('bluetooth')"
                            :class="{
                                active: deviceTab === 'bluetooth' && deviceIsEnableBtTab,
                                'device-list__tab--disable': !deviceIsEnableBtTab,
                            }"
                        >
                            {{ $t('translation.blueTooth') }}
                        </div>
                        <div
                            class="device-list__tab"
                            @click="changeTab('usb')"
                            :class="{
                                active: deviceTab === 'usb' && deviceIsEnableUsbTab,
                                'device-list__tab--disable': !deviceIsEnableUsbTab,
                            }"
                        >
                            {{ $t('translation.usb') }}
                        </div>
                    </div>
                    <div v-if="deviceTab === 'bluetooth'" class="device-list__list">
                        <div
                            v-for="device in deviceScanned"
                            v-if="device.type === 'bluetooth'"
                            class="device-list__item"
                            @click.stop="select(device)"
                            :class="{
                                'connected': device.id === deviceConnected.id,
                                'active': device.id === deviceConnected.id || device.id === selected.id,
                            }"
                        >
                            <div class="device-list__text">{{ device.name }}</div>
                            <div v-if="device.id === deviceConnected.id" class="device-list__status">
                                {{ $t('translation.connected') }}
                            </div>
                            <button
                                v-if="device.id === deviceConnected.id"
                                @click.stop="disconnect(device)"
                                class="device-list__disconnect"
                            >
                                {{ $t('translation.disconnect') }}
                            </button>
                        </div>
                    </div>
                    <div v-if="deviceTab === 'usb'" class="device-list__list">
                        <div
                            v-for="device in deviceScanned"
                            v-if="device.type === 'usb'"
                            class="device-list__item"
                            @click.stop="select(device)"
                            :class="{
                                'connected': device.id === deviceConnected.id,
                                'active': device.id === deviceConnected.id || device.id === selected.id,
                            }"
                        >
                            <div class="device-list__text">{{ device.name }}</div>
                            <div v-if="device.id === deviceConnected.id" class="device-list__status">
                                {{ $t('translation.connected') }}
                            </div>
                            <button
                                v-if="device.id === deviceConnected.id"
                                @click.stop="disconnect(device)"
                                class="device-list__disconnect"
                            >
                                {{ $t('translation.disconnect') }}
                            </button>
                        </div>
                    </div>
                </div>
                <div v-if="true" class="device-list__connect">
                    <button class="button-secondary" @click="connect">{{ $t('translation.connect') }}</button>
                </div>
            </div>

            <div class="communication__line"></div>

            <div class="communication__terminal terminal">
                <h4 class="terminal__header">{{ $t('translation.terminal') }}</h4>

                <div class="terminal__body" ref="terminal">
                    <span v-for="terminalData in deviceTerminalData" class="terminal__text">{{ terminalData.text }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import deviceMixin from '../../../mixins/device';

    export default {
        mixins: [
            deviceMixin,
        ],
        data() {
            return {
                selected: {},
            };
        },
        methods: {
            changeTab(value) {
                if (value === 'usb' && this.deviceIsEnableUsbTab) {
                    this.deviceTab = value;
                } else if (value === 'bluetooth' && this.deviceIsEnableBtTab) {
                    this.deviceTab = value;
                }
            },
            disconnect(device) {
                this.$store.dispatch('device/disconnectDevice', {});

                try {
                    window.invokeCSCode('disconnect');
                } catch (e) {
                    // Code
                }
            },
            select(device) {
                this.selected = device;
            },
            connect() {
                this.$store.dispatch('device/connectDevice', this.selected);

                try {
                    window.invokeCSCode('connect');
                } catch (e) {
                    // Code
                }
            },
            scanDevice() {
                try {
                    window.invokeCSCode('scan-device');
                } catch (e) {
                    // Code
                }
            },
        },
        watch: {
            deviceTerminalData() {
                this.$nextTick(() => {
                    const terminal = this.$refs.terminal;
                    terminal.scrollTop = terminal.scrollHeight + 100;
                });
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/Code/rightbar/Communication.vue